import { SUPPORT_EMAIL_ADDRESS, SUPPORT_EMAIL_GUIDANCE } from '../copy/onboardingStatus';

function BetaHelpPage() {
  return (
    <div className="page page-shell beta-help-page">
      <section className="beta-help-hero">
        <p className="eyebrow">Controlled beta</p>
        <h1>Beta Help</h1>
        <p>
          Sumrise beta is ready for supervised tutor-led use, but it is still being improved.
          Use tutor judgment when a question, upload, or mark looks uncertain.
        </p>
      </section>

      <section className="beta-help-grid" aria-label="Beta guidance">
        <article className="card beta-help-card">
          <h2>What Beta Means</h2>
          <p>
            Beta feedback helps improve Sumrise before wider use. Do not use beta marks as
            the only source of truth for grades, predicted results, or high-stakes decisions.
          </p>
        </article>

        <article className="card beta-help-card">
          <h2>Clear Uploads</h2>
          <ul>
            <li>Place the page flat in bright, even light.</li>
            <li>Keep the whole answer visible and avoid shadows or glare.</li>
            <li>Take one page at a time unless asked otherwise.</li>
            <li>Retake photos that are blurry, cropped, sideways, or too small.</li>
          </ul>
        </article>

        <article className="card beta-help-card">
          <h2>iPhone Photos</h2>
          <p>
            HEIC/HEIF photos from iPhones are supported. If an upload fails, retake it,
            crop closer to the page, or send it as JPEG or PNG.
          </p>
        </article>

        <article className="card beta-help-card">
          <h2>When Marking Looks Wrong</h2>
          <p>
            Pause and ask for review. Tell your tutor or beta support contact if OCR missed
            working, read the final answer incorrectly, or the mark or feedback does not match
            the work shown.
          </p>
        </article>

        <article className="card beta-help-card beta-help-card-wide" id="report-issue">
          <h2>Report Issue</h2>
          <p>
            Choose <strong>Report issue</strong> in the navigation, pick the kind of issue,
            and tell us what happened in one sentence. Sumrise attaches the page and technical
            details automatically.
          </p>
          <ul>
            <li>Say what you were trying to do and what happened instead.</li>
            <li>You do not need to copy page, session, question, time, or request details.</li>
            <li>Screenshot or photo only when it is safe to share.</li>
          </ul>
        </article>

        <article className="card beta-help-card">
          <h2>Do Not Send</h2>
          <ul>
            <li>Passwords, login codes, auth tokens, invite links, or reset links.</li>
            <li>Raw provider, OCR, or LLM output.</li>
            <li>Sensitive personal information or private notes not needed for support.</li>
            <li>Sensitive screenshots unless your beta support contact asks for them.</li>
          </ul>
        </article>

        <article className="card beta-help-card">
          <h2>Support Expectations</h2>
          <p>
            Urgent access, safety, privacy, or clearly wrong marking issues should be raised
            immediately. Smaller quality issues may be grouped into the next beta triage pass.
          </p>
          <p>
            If you cannot use the in-app report form, email{' '}
            <a href={`mailto:${SUPPORT_EMAIL_ADDRESS}`}>{SUPPORT_EMAIL_ADDRESS}</a>.{' '}
            {SUPPORT_EMAIL_GUIDANCE}
          </p>
        </article>
      </section>
    </div>
  );
}

export default BetaHelpPage;
